import { render, staticRenderFns } from "./OrganizationContextSwitcher.vue?vue&type=template&id=733d4558&"
import script from "./OrganizationContextSwitcher.vue?vue&type=script&lang=js&"
export * from "./OrganizationContextSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports